var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlayListFavourite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.998 11c.002-.47.002.03.002-.5 0-4.478 0-6.718-1.391-8.109C17.217 1 14.979 1 10.5 1 6.022 1 3.782 1 2.391 2.391S1 6.021 1 10.5c0 4.478 0 6.718 1.391 8.109S6.021 20 10.5 20h.5",
    stroke: "#376E66",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 6h19M15.5 1l-3 5M8.5 1l-3 5",
    stroke: "#376E66",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.015 14.387c1.073-.64 2.009-.382 2.571.028.23.169.346.253.414.253s.183-.084.414-.253c.562-.41 1.498-.668 2.571-.028 1.408.84 1.726 3.609-1.52 5.945-.62.445-.928.668-1.465.668s-.846-.223-1.464-.668c-3.247-2.336-2.929-5.106-1.521-5.945z",
    stroke: "#376E66",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
export default SvgIconPlayListFavourite;